module.exports = __webpack_public_path__ + "static/media/CaviarDreams.3670aa49.ttf";